import * as _gensync3 from "gensync";
var _gensync2 = _gensync3;
try {
  if ("default" in _gensync3) _gensync2 = _gensync3.default;
} catch (e) {}
import { dew as _index3Dew } from "./config/index.js";
import { dew as _index4Dew } from "./transformation/index.js";
import { dew as _rewriteStackTrace2Dew } from "./errors/rewrite-stack-trace.js";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.transform = void 0;
  exports.transformAsync = transformAsync;
  exports.transformSync = transformSync;
  function _gensync() {
    const data = _gensync2;
    _gensync = function () {
      return data;
    };
    return data;
  }
  var _index = _index3Dew();
  var _index2 = _index4Dew();
  var _rewriteStackTrace = _rewriteStackTrace2Dew();
  const transformRunner = _gensync()(function* transform(code, opts) {
    const config = yield* (0, _index.default)(opts);
    if (config === null) return null;
    return yield* (0, _index2.run)(config, code);
  });
  const transform = function transform(code, optsOrCallback, maybeCallback) {
    let opts;
    let callback;
    if (typeof optsOrCallback === "function") {
      callback = optsOrCallback;
      opts = undefined;
    } else {
      opts = optsOrCallback;
      callback = maybeCallback;
    }
    if (callback === undefined) {
      {
        return (0, _rewriteStackTrace.beginHiddenCallStack)(transformRunner.sync)(code, opts);
      }
    }
    (0, _rewriteStackTrace.beginHiddenCallStack)(transformRunner.errback)(code, opts, callback);
  };
  exports.transform = transform;
  function transformSync(...args) {
    return (0, _rewriteStackTrace.beginHiddenCallStack)(transformRunner.sync)(...args);
  }
  function transformAsync(...args) {
    return (0, _rewriteStackTrace.beginHiddenCallStack)(transformRunner.async)(...args);
  }
  0 && 0;

  //# sourceMappingURL=transform.js.map
  return exports;
}